<template>
  <v-card
    :min-height="minHeight"
    data-testid="vertical-spacer"
    elevation="0"
    style="background-color: transparent"
  />
</template>

<script setup>
defineProps({
  minHeight: {
    type: Number,
    default: null,
  },
});
</script>
